import Testimonies from './Testimonies';
export default Testimonies;
